<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="cf_workers"
            :url="url"
            :columns="columnList"
            :tableHeight="tableHeight"
            :searchLocal="false"
            :buttons="buttons"
            :selection="true"
            @selectionChange="loadChecked"
            :addButton="{ permission: 'worker:create' }"
            :deleteButton="{ permission: 'worker:delete' }"
            :updateButton="{ enabled: false, permission: 'worker:update' }"
            @CreateUser="CreateUser"
            @printbar="printbar"
        >
                    <template slot="filter-after">
                <el-button type="primary" size="mini" v-has-permission="batchCreateUserPermission"  @click="batchCreateUser()">批量创建账户</el-button>
            </template>
        </crud-facecade>
        <el-pagination class="align-left" background layout="total, sizes, prev, pager, next, jumper" @size-change="refreshList"
            @current-change="refreshList" :page-sizes="[10, 20, 50, 100, 200]" :current-page.sync="currentPage"
            :page-size.sync="pageSize" :total="total">
        </el-pagination>
        <form-dialog
            ref="form_create_user"
            :title="createUser.title"
            :data="createUser.data"
            :visible.sync="createUser.dialogFormVisible"
            :columns="createUser.columns"
            @confirm="SaveUser"
        ></form-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import printJs from 'print-js'
export default {
    name: `Worker`,
    props: {},
    data() {
        let me = this
        return {
            title: `员工信息`,
            currentPage: 1,
            pageSize: 50,
            total: 0,
            fileUploadConfig: this.$root.FileUploadConfig,
            passwordMode: this.$root.PasswordMode,
            passwordMaxErrorCount: this.$root.PasswordMaxErrorCount,
            passwordExpiredRemindDays: this.$root.PasswordExpiredRemindDays,
            passwordRegularExpression: this.$root.PasswordRegularExpression,
            passwordRegularTipMsg: this.$root.PasswordRegularTipMsg,
            resetDefaultPassword: this.$root.ResetDefaultPassword,
            plan: [],
            batchusers: [],
            url: {
                baseURL: `/api/AcisSystem/Worker`,
                get: q => {
                    let that = this
                    q.page = that.currentPage
                    q.pageSize = that.pageSize
                    return new Promise(resolve => {
                        let req = that.myaxios.postpagination(`/api/AcisSystem/Worker/GetPageNew`, q
                        )
                        req.then(res => {
                            res.data.map(d => {
                                d.accounts = _.join(d.account_names)
                            })
                            this.total = res.count
                            var data = res.data
                            resolve(data)
                        }).catch(e => {
                            console.log(e)
                            resolve([])
                        })
                    })
                },
                getOne: (row) => {
                    this.currentid = row.id
                    return new Promise((resolve, reject) => {
                        // 获取照片列表名字
                        let req = this.myaxios.get(`/api/AcisSystem/Worker/GetFileNames/${row.id}`)
                        req.then(data => {
                            let fs = _.groupBy(data, d3 => {
                                return d3.indexOf(`.pdf`) == -1 ? `image` : `pdf`
                            })
                            let r = { ...row }
                            // 获取照片全路径
                            r.picture = fs && fs.image && fs.image.map(d => {
                                return {
                                    name: d,
                                    url: `${this.$root.BASE_URL}api/AcisSystem/Worker/GetPictureFile/${row.id}?fileName=${d}`,
                                    uid: `p${row.id}`
                                }
                            }) || []
                            resolve(r)
                        })
                    })
                }
            },
            buttons: [
                {
                    label: `创建账户`,
                    type: `primary`,
                    emit: `CreateUser`,
                    permission: `default` // user:assignRole
                },
                {
                    class: `is-plain`,
                    label: `打印二维码`,
                    type: `primary`,
                    emit: `printbar`,
                    permission: `default`
                },
                {
                    class: `is-plain`,
                    label: `编辑`,
                    type: `primary`,
                    emit: `LoadingUpdateView`,
                    permission: `default`
                }
            ],
            createUser: {
                title: `创建账户`,
                dialogFormVisible: false,
                columns: [
                    {
                        type: `textarea`,
                        prop: `username`,
                        label: `登录名`,
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                        readonly: function(that, { row, column, area }) {
                            return me.createUser.isBatch
                        },
                        colspan: 24
                    },
                    {
                        type: `string`,
                        prop: `password`,
                        label: `密码`,
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                        colspan: 24
                    },
                    {
                        type: `checkboxgroup`,
                        prop: `role`,
                        label: `角色`,
                        options: `sysuser/roles`,
                        colspan: 24
                    }
                ],
                data: {
                    username: ``,
                    password: ``,
                    role: []
                },
                isBatch: false
            },
            checkedRow: [],
            batchCreateUserPermission: `worker:batchCreateUser`
        }
    },
    created() {
        this.$store.dispatch(`ADD_SECTION`)
        this.$store.dispatch(`sysuser/ADD_ROLES`)
        this.initData()
    },
    computed: {
        ...mapGetters([`section`, `sysuser/roles`, `sys_enums`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    // width: "180",
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `card_no`,
                    label: `员工号`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false,
                    colspan: 8,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `姓名`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false,
                    colspan: 8,
                    // sortable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `enum_sex`,
                    label: `性别`,
                    colspan: 8,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    options: this.sys_enums.Enum_Sex || []
                },
                {
                    type: `select`,
                    prop: `card_type`,
                    label: `证件类型`,
                    colspan: 8,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_CardType || [],
                    config: { popperAppendToBody: true }
                },
                {
                    type: `string`,
                    prop: `id_card_no`,
                    label: `证件号`,
                    colspan: 8,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true
                },
                {
                    type: `string`,
                    prop: `telephone`,
                    label: `手机号`,
                    colspan: 8,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true
                },
                {
                    type: `date`,
                    prop: `birthday`,
                    label: `出生日期`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    colspan: 8,
                    // sortable: true,
                    searchable: true
                },
                {
                    type: `date`,
                    prop: `entry_time`,
                    label: this.T(`worker.entry_time`),
                    isCreatable: true,
                    isListable: true,
                    isEditable: true,
                    colspan: 8
                },
                {
                    type: `select`,
                    prop: `dic_attendance_plan_Id`,
                    label: `考勤方案`,
                    colspan: 8,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true,
                    options: this.plan
                },
                {
                    type: `select`,
                    prop: `dic_section_id`,
                    label: `科室`,
                    colspan: 8,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: this[`section`],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                }, {
                    type: `multiselect`,
                    prop: `sectionids`,
                    label: `多科室`,
                    colspan: 8,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: this[`section`]
                },
                {
                    type: `multiselect`,
                    prop: `rotation_sectionids`,
                    label: `轮转科室`,
                    colspan: 8,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: this[`section`]
                },
                {
                    type: `string`,
                    prop: `degree`,
                    label: `学历`,
                    colspan: 8,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true
                },
                // {
                //     type: `string`,
                //     prop: `cycle`,
                //     label: `轮转`,
                //     isListable: true,
                //     isCreatable: true,
                //     isEditable: true
                // },
                {
                    type: `string`,
                    prop: `study`,
                    label: `进修`,
                    colspan: 8,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true
                },
                {
                    type: `string`,
                    prop: `awards`,
                    label: `获奖情况`,
                    colspan: 8,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true
                },
                {
                    type: `select`,
                    prop: `enum_worker_role`,
                    label: `属性`,
                    colspan: 8,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    options: this.sys_enums.Enum_WorkerRole || []
                },
                {
                    type: `select`,
                    prop: `enum_worker_duty`,
                    label: `职务`,
                    colspan: 8,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    options: this.sys_enums.WorkerDuty || []
                },
                {
                    type: `select`,
                    prop: `enum_professional`,
                    label: `职称`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    colspan: 8,
                    options: this.sys_enums.Enum_Professional || []
                },
                {
                    type: `select`,
                    prop: `enum_post`,
                    label: `岗位`,
                    isCreatable: true,
                    isListable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_Post || [],
                    colspan: 8
                },
                {
                    type: `string`,
                    prop: `teaching_qualifications`,
                    label: `教学资质`,
                    colspan: 8,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true
                }, {
                    type: `string`,
                    prop: `sansheng_qualifications`,
                    label: `三生资质`,
                    colspan: 8,
                    isCreatable: true,
                    isEditable: true
                }, {
                    type: `select`,
                    prop: `enum_surgery_scale`,
                    label: `手术医生资格等级`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    options: this.sys_enums.Enum_SurgeryScale || [],
                    isCreatable: true,
                    colspan: 8,
                    searchable: true
                },
                {
                    type: `select`,
                    prop: `enum_asa`,
                    label: `麻醉医生资格等级`,
                    isCreatable: true,
                    isListable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_ASA || [],
                    colspan: 8
                },
                {
                    type: `string`,
                    prop: `medical_qualifications`,
                    label: `医疗资质`,
                    colspan: 8,
                    isCreatable: true,
                    isEditable: true
                },
                {
                    type: `select`,
                    prop: `enum_nurse_scale`,
                    label: `护士资格等级`,
                    isCreatable: true,
                    isListable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_NurseScale || [],
                    colspan: 8,
                    width: 100
                },
                {
                    type: `select`,
                    prop: `enum_level`,
                    label: `层级`,
                    isCreatable: true,
                    isListable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_Level || [],
                    colspan: 8
                },

                {
                    type: `string`,
                    prop: `nursing_qualifications`,
                    label: `护理资质`,
                    colspan: 8,
                    isCreatable: true,
                    isEditable: true
                },
                {
                    type: `string`,
                    prop: `manager_room_count`,
                    label: `最大管理房间数量`,
                    colspan: 24,
                    isCreatable: true,
                    isEditable: true
                },
                {
                    type: `string`,
                    prop: `teaching_teacher`,
                    label: `带教老师`,
                    colspan: 8,
                    isCreatable: true,
                    isEditable: true
                },
                {
                    type: `date`,
                    prop: `teaching_start`,
                    label: `带教开始时间`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 8
                },
                {
                    type: `date`,
                    prop: `teaching_end`,
                    label: `带教结束时间`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 8
                },
                {
                    type: `textarea`,
                    prop: `remark`,
                    label: `描述`,
                    colspan: 24,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false
                },
                // , {
                //   type: "string",
                //   prop: "head_pic_path",
                //   label: "头像",
                //   width: "100",
                //   isListable: true,
                //   isExpand: false,
                //   isEditable: true,
                //   isCreatable: true,
                // }

                {
                    type: `string`,
                    prop: `accounts`,
                    label: `账户`,
                    colspan: 8,
                    isListable: true
                },
                {
                    type: `rbool`,
                    prop: `is_deleted`,
                    label: `状态`,
                    colspan: 8,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: false,
                    readonly: false,
                    options: `is_enabled`,
                    default: false
                },
                {
                    type: `bool`,
                    prop: `is_system`,
                    label: `是否系统员工`,
                    colspan: 8,
                    isListable: false,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false,
                    sortable: false,
                    readonly: false,
                    options: `enum_bool`,
                    default: false
                }, {
                    type: `upload`,
                    prop: `picture`,
                    label: `照片`,
                    isEditable: true,
                    isCreatable: true,
                    colspan: 24,
                    options: (that, { row }) => {
                        // 上传照片
                        return `${this.$root.BASE_URL}api/AcisSystem/Worker/PostFiles/${row.origion.id}?extensionsType=ImageExtensions`
                    },
                    config: {
                        multipleLimit: 1,
                        accept: `image/jpeg`,
                        onExceed: (files, fileList) => {
                            this.$message.warning(`超过最大文件数`)
                        },
                        removeFile: (file, fileList) => {
                            // 删除照片
                            let req = this.myaxios.delete(`/api/AcisSystem/Worker/DeleteFile/${this.currentid}?fileName=${file.name}`)
                            req.then(data => {})
                        },
                        beforeUpload: (file) => {
                            let fileconfig = JSON.parse(this.fileUploadConfig)
                            let extensions = fileconfig && fileconfig.ImageExtensions ? fileconfig.ImageExtensions.split(`,`) : []
                            let maxSize = Number(fileconfig.MaxSize) * 1024 * 1024

                            if (!(file.size < maxSize)) {
                                this.$message.error(`上传文件大小不能超过[${fileconfig.MaxSize}]MB!`)
                                return false
                            }
                            let filetype = file.name.split(`.`).slice(-1)[0].toLowerCase()
                            if (!_.includes(extensions, `.` + filetype)) {
                                this.$message.error(`上传文件只能是[${fileconfig.ImageExtensions}]格式!`)
                                return false
                            }
                        }
                    }
                }
            ]
        }
    },
    mounted() {},
    methods: {
        refreshList() {
            this.$refs[`cf_workers`].ReloadListData()
        },
        initData() {
            return new Promise((resolve, reject) => {
                let req1 = this.myaxios.get(`/api/AcisSystem/AttendancePlan/Get`)
                this.myaxios
                    .all(req1)
                    .then(([data1]) => {
                        this.plan = _.map(data1, d => {
                            return {
                                value: d.id,
                                label: d.name || `--`,
                                disabled: d.status != 1
                            }
                        })
                    })
                    .catch(e => {
                        console.log(e)
                        reject(e)
                    })
            })
        },
        batchCreateUser() {
            this.batchusers = []
            let req = this.myaxios.get(`/api/AcisSystem/Worker/GetNoUserWorkers`)
            req.then(datas => {
                console.log(datas)
                if (datas.length > 0) {
                    this.$confirm(`即将给所有非系统级，并且不存在账号的员工创建账号, 是否继续?`, `提示`, {
                        confirmButtonText: `确定`,
                        cancelButtonText: `取消`,
                        type: `warning`,
                        closeOnClickModal: false
                    }).then(() => {
                        this.batchusers = datas
                        let names = datas.map(item => item.card_no).join(`,`)
                        this.createUser.title = `批量创建账户`
                        this.createUser.data.password = this.resetDefaultPassword
                        this.createUser.data.username = names
                        this.createUser.dialogFormVisible = true
                        this.createUser.isBatch = true
                    })
                } else {
                    this.$message.error(`没有需要创建账号的员工`)
                }
            })
        },
        loadChecked({ row }) {
            this.checkedRow = row
        },
        CreateUser({ row }) {
            this.createUser.title = row.name
            this.createUser.data.dic_worker_id = row.id
            this.createUser.data.dic_worker_name = row.name
            this.createUser.data.card_no = row.card_no
            this.createUser.data.username = row.card_no
            this.createUser.data.password = this.resetDefaultPassword
            this.createUser.dialogFormVisible = true
            this.createUser.isBatch = false
        },
        printbar({ row }) {
            let req = this.myaxios.get(`/api/AcisSystem/Worker/CreateQRCode/${row.id}`)
            req.then(data => {
                printJs({ printable: `data:image/jpeg;base64,` + data, type: `image`, base64: true, maxWidth: 1500 })
            })
        },
        SaveUser(data) {
            let that = this
            // 如果启用正则验证，校验正则
            if (this.passwordMode == `1`) {
                if (!data.password.match(this.passwordRegularExpression)) {
                    this.$message.error(this.passwordRegularTipMsg)
                    return
                }
            }
            if (!this.createUser.isBatch) {
                let data2 = {
                    username: data.username,
                    password: data.password,
                    dic_worker_id: this.createUser.data.dic_worker_id,
                    dic_worker_name: this.createUser.data.dic_worker_name,
                    card_no: this.createUser.data.card_no,
                    role_ids: data.role,
                    enum_asa: this.enum_asa,
                    surgery_scale: this.enum_surgery_scale,
                    enum_nurse_scale: this.enum_nurse_scale,
                    entry_time: this.entry_time,
                    enum_post: this.enum_post,
                    enum_level: this.enum_level

                }
                this.myaxios
                    .post(`/api/AcisSystem/SysUser/Post`, data2)
                    .then(data => {
                        that.$refs.cf_workers.ReloadListData()
                        that.createUser.dialogFormVisible = false
                        // console.log(data)
                    })
            } else {
                let data2 = []
                data2 = this.batchusers.map((item, i) => {
                    let itemname = {
                        username: item.card_no,
                        password: data.password,
                        dic_worker_id: item.id,
                        dic_worker_name: item.name,
                        card_no: item.card_no,
                        role_ids: data.role
                    }
                    return itemname
                })
                if (data2.length == 0) {
                    this.$message.error(`请选择创建账户`)
                    return
                }
                this.myaxios
                    .post(`/api/AcisSystem/SysUser/PostMany`, data2)
                    .then(data => {
                        that.$message.success(`批量创建成功`)
                        that.$refs.cf_workers.ReloadListData()
                        that.createUser.dialogFormVisible = false
                    })
            }
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Worker/Index.vue